import { splitMix32 } from "@/realize-shared/Random";
import * as Util from "./Util";

// @todo
// stolen from here: https://prowritingaid.com/positive-adjectives
// replace with our own
const adjectives = [
    "Abundant",
    "Accomplished",
    "Adaptable",
    "Adept",
    "Adventurous",
    "Affable",
    "Affectionate",
    "Agreeable",
    "Agricultural",
    "Alive",
    "Alluring",
    "Amazing",
    "Ambitious",
    "Amiable",
    "Amicable",
    "Ample",
    "Amusing",
    "Approachable",
    "Articulate",
    "Astronomical",
    "Attractive",
    "Awesome",
    "Beautiful",
    "Blazing",
    "Blithesome",
    "Boundless",
    "Bountiful",
    "Brave",
    "Breath-taking",
    "Bright",
    "Brilliant",
    "Broad-minded",
    "Bustling",
    "Calm",
    "Capable",
    "Captivating",
    "Careful",
    "Charismatic",
    "Charming",
    "Chatty",
    "Cheerful",
    "Colossal",
    "Colourful",
    "Communicative",
    "Compassionate",
    "Competitive",
    "Confident",
    "Conscientious",
    "Considerate",
    "Convivial",
    "Cosmopolitan",
    "Courageous",
    "Courteous",
    "Creative",
    "Dazzling",
    "Decisive",
    "Dependable",
    "Determined",
    "Devoted",
    "Diligent",
    "Diplomatic",
    "Discreet",
    "Dramatic",
    "Dusky",
    "Dynamic",
    "Easy-going",
    "Educated",
    "Efficient",
    "Elegant",
    "Emotional",
    "Enchanted",
    "Enchanting",
    "Energetic",
    "Engaging",
    "Enlightened",
    "Enthusiastic",
    "Excellent",
    "Expert",
    "Extensive",
    "Exuberant",
    "Fabulous",
    "Fair-minded",
    "Fairy-tale-like",
    "Faithful",
    "Fantastic",
    "Far-flung",
    "Fascinating",
    "Favourable",
    "Fearless",
    "Fertile",
    "Flexible",
    "Focused",
    "Forceful",
    "Frank",
    "Fresh",
    "Friendly",
    "Funny",
    "Generous",
    "Gentle",
    "Giving",
    "Gleaming",
    "Glimmering",
    "Glistening",
    "Glittering",
    "Glowing",
    "Good",
    "Gorgeous",
    "Gregarious",
    "Hard-working",
    "Harmonious",
    "Helpful",
    "Hilarious",
    "Historic",
    "Homey",
    "Honest",
    "Humorous",
    "Imaginative",
    "Immaculate",
    "Immeasurable",
    "Immense",
    "Impartial",
    "Imposing",
    "Impressive",
    "Incredible",
    "Independent",
    "Indescribable",
    "Inquisitive",
    "Insightful",
    "Inspiring",
    "Intellectual",
    "Intelligent",
    "Intuitive",
    "Inventive",
    "Kind",
    "Knowledgeable",
    "Kooky",
    "Laid-back",
    "Likeable",
    "Lively",
    "Lovely",
    "Loving",
    "Loyal",
    "Lush",
    "Lustrous",
    "Luxurious",
    "Magical",
    "Magnificent",
    "Majestic",
    "Marvellous",
    "Massive",
    "Meandering",
    "Mirthful",
    "Modest",
    "Monumental",
    "Mountainous",
    "Mysterious",
    "Mystical",
    "Neat",
    "Nice",
    "Nostalgic",
    "Observant",
    "Open-minded",
    "Optimistic",
    "Organized",
    "Outstanding",
    "Palatial",
    "Passionate",
    "Pastoral",
    "Patient",
    "Peaceful",
    "Perfect",
    "Persistent",
    "Personable",
    "Philosophical",
    "Picturesque",
    "Pioneering",
    "Placid",
    "Pleasant",
    "Plucky",
    "Polite",
    "Powerful",
    "Practical",
    "Pro-active",
    "Productive",
    "Proficient",
    "Propitious",
    "Prosperous",
    "Qualified",
    "Quick-witted",
    "Quiet",
    "Rational",
    "Ravishing",
    "Relaxed",
    "Reliable",
    "Remarkable",
    "Reserved",
    "Resourceful",
    "Responsible",
    "Romantic",
    "Rousing",
    "Rural",
    "Sandy",
    "Self-confident",
    "Self-disciplined",
    "Sensational",
    "Sensible",
    "Sensitive",
    "Serene",
    "Shiny",
    "Sincere",
    "Sleek",
    "Sociable",
    "Spacious",
    "Spectacular",
    "Splendid",
    "Stellar",
    "Straightforward",
    "Stunning",
    "Stupendous",
    "Sun-drenched",
    "Super",
    "Superb",
    "Sympathetic",
    "Technological",
    "Terrific",
    "Thoughtful",
    "Tidy",
    "Tough",
    "Towering",
    "Tranquil",
    "Trustworthy",
    "Twinkling",
    "Unassuming",
    "Understanding",
    "Unique",
    "Unspoiled",
    "Upbeat",
    "Vast",
    "Versatile",
    "Vibrant",
    "Vivacious",
    "Vivid",
    "Warm-hearted",
    "Willing",
    "Witty",
    "Wondrous",
];

// @todo
// stolen from here: https://a-z-animals.com/animals/
// Probably look into seeing if any of these are outright slurs and removing them
const wordset2 = [
    "Aardvark",
    "Aardwolf",
    "Abyssinian",
    "Addax",
    "Affenpinscher",
    "Agouti",
    "Aidi",
    "Ainu",
    "Airedoodle",
    "Akbash",
    "Akita",
    "Alabai ",
    "Albatross",
    "Albertonectes",
    "Allosaurus",
    "Alpaca",
    "Alusky",
    "Amargasaurus",
    "Amberjack",
    "Anaconda",
    "Anchovies",
    "Andrewsarchus",
    "Angelfish",
    "Angelshark",
    "Anglerfish",
    "Anhinga",
    "Anomalocaris",
    "Ant",
    "Anteater",
    "Antelope",
    "Anteosaurus",
    "Ape",
    "Arambourgiania",
    "Arapaima",
    "Archaeoindris",
    "Archaeopteryx",
    "Archaeotherium",
    "Archerfish",
    "Arctodus",
    "Arctotherium",
    "Argentinosaurus",
    "Armadillo",
    "Armyworm",
    "Arsinoitherium",
    "Arthropleura",
    "Asp",
    "Aurochs",
    "Aussiedoodle",
    "Aussiedor",
    "Aussiepom",
    "Australopithecus",
    "Avocet",
    "Axolotl",
    "Aye-aye",
    "Azawakh",
    "Babirusa",
    "Baboon",
    "Badger",
    "Baiji",
    "Balinese",
    "Bandicoot",
    "Barb",
    "Barbet",
    "Barinasuchus",
    "Barnacle",
    "Barnevelder",
    "Barosaurus",
    "Barracuda",
    "Barylambda",
    "Basilosaurus",
    "Bass",
    "Bassador",
    "Bassetoodle",
    "Bat",
    "Batfish",
    "Baya",
    "Bea-Tzu",
    "Beabull",
    "Beagador",
    "Beagle",
    "Beaglier",
    "Beago",
    "Bear",
    "Beaski",
    "Beauceron",
    "Beaver",
    "Bee",
    "Bee-Eater",
    "Beefalo",
    "Beetle",
    "Bergamasco",
    "Bernedoodle",
    "Bichir",
    "Bichpoo",
    "Bilby",
    "Binturong",
    "Bird",
    "Birman",
    "Bison",
    "Blobfish",
    "Bloodhound",
    "Blowfly",
    "Bluefish",
    "Bluegill",
    "Boas",
    "Bobcat",
    "Bobolink",
    "Boerboel",
    "Boggle",
    "Boiga",
    "Bombay",
    "Bonefish",
    "Bongo",
    "Bonobo",
    "Booby",
    "Boomslang",
    "Borador",
    "Bordoodle",
    "Borkie",
    "Boskimo",
    "Bowfin",
    "Boxachi",
    "Boxador",
    "Boxerdoodle",
    "Boxfish",
    "Boxsky",
    "Boxweiler",
    "Brachiosaurus",
    "Briard",
    "Brittany",
    "Brontosaurus",
    "Brug",
    "Budgerigar",
    "Buffalo",
    "Bullboxer",
    "Bulldog",
    "Bullfrog",
    "Bullmastiff",
    "Bullsnake",
    "Bumblebee",
    "Burmese",
    "Butterfly",
    "Caecilian",
    "Caiman",
    "Camel",
    "Cantil",
    "Canvasback",
    "Capuchin",
    "Capybara",
    "Caracal",
    "Cardinal",
    "Caribou",
    "Carp",
    "Cascabel",
    "Cassowary",
    "Cat",
    "Caterpillar",
    "Catfish",
    "Cavador",
    "Cavapoo",
    "Centipede",
    "Cephalaspis",
    "Ceratopsian",
    "Ceratosaurus",
    "Chameleon",
    "Chamois",
    "Chartreux",
    "Cheagle",
    "Cheetah",
    "Chickadee",
    "Chicken",
    "Chigger",
    "Chihuahua",
    "Chilesaurus",
    "Chimaera",
    "Chimpanzee",
    "Chinchilla",
    "Chinook",
    "Chipit",
    "Chipmunk",
    "Chipoo",
    "Chiton",
    "Chiweenie",
    "Chorkie",
    "Chusky",
    "Cicada",
    "Cichlid",
    "Clownfish",
    "Coati",
    "Cobras",
    "Cockalier",
    "Cockapoo",
    "Cockatiel",
    "Cockatoo",
    "Cockle",
    "Cockroach",
    "Codfish",
    "Coelacanth",
    "Collie",
    "Compsognathus",
    "Conure",
    "Copperhead",
    "Coral",
    "Corella",
    "Corgidor",
    "Corgipoo",
    "Corkie",
    "Cormorant",
    "Coryphodon",
    "Cottonmouth",
    "Cougar",
    "Cow",
    "Coyote",
    "Crab",
    "Crane",
    "Crayfish",
    "Cricket",
    "Crocodile",
    "Crocodylomorph",
    "Crow",
    "Cryolophosaurus",
    "Cuckoo",
    "Cuttlefish",
    "Dachsador",
    "Dachshund",
    "Daeodon",
    "Dalmadoodle",
    "Dalmador",
    "Dalmatian",
    "Damselfish",
    "Daniff",
    "Danios",
    "Daug",
    "Deer",
    "Deinocheirus",
    "Deinosuchus",
    "Desmostylus",
    "Dhole",
    "Dickcissel",
    "Dickinsonia",
    "Dik-Dik",
    "Dilophosaurus",
    "Dimetrodon",
    "Dingo",
    "Dinocrocuta",
    "Dinofelis",
    "Dinopithecus",
    "Dinosaurs",
    "Diplodocus",
    "Diprotodon",
    "Discus",
    "Dobsonfly",
    "Dodo",
    "Doedicurus",
    "Dog",
    "Dolphin",
    "Donkey",
    "Dorgi",
    "Dorkie",
    "Dormouse",
    "Douc",
    "Doxiepoo",
    "Doxle",
    "Dragonfish",
    "Dragonfly",
    "Dreadnoughtus",
    "Drever",
    "Duck",
    "Dugong",
    "Dunker",
    "Dunkleosteus",
    "Dunnock",
    "Eagle",
    "Earthworm",
    "Earwig",
    "Echidna",
    "Eel",
    "Eelpout",
    "Egret",
    "Eider",
    "Eland",
    "Elasmosaurus",
    "Elasmotherium",
    "Elephant",
    "Elk",
    "Embolotherium",
    "Emu",
    "Epidexipteryx",
    "Ermine",
    "Eryops",
    "Escolar",
    "Eskipoo",
    "Euoplocephalus",
    "Eurasier",
    "Eurypterus",
    "Fairy-Wren",
    "Falcon",
    "Fangtooth",
    "Feist",
    "Ferret",
    "Finch",
    "Firefly",
    "Fish",
    "Fisher",
    "Flamingo",
    "Flea",
    "Flounder",
    "Fly",
    "Flycatcher",
    "Fossa",
    "Fox",
    "Frenchton",
    "Frengle",
    "Frigatebird",
    "Frog",
    "Frogfish",
    "Frug",
    "Gadwall",
    "Gar",
    "Gastornis",
    "Gazelle",
    "Gecko",
    "Genet",
    "Gerbil",
    "Gharial",
    "Gibbon",
    "Gigantopithecus",
    "Giraffe",
    "Glechon",
    "Glowworm",
    "Gnat",
    "Goat",
    "Goberian",
    "Goldador",
    "Goldcrest",
    "Goldendoodle",
    "Goldfish",
    "Gollie",
    "Gomphotherium",
    "Goose",
    "Gopher",
    "Goral",
    "Gorgosaurus",
    "Gorilla",
    "Goshawk",
    "Gourami",
    "Grasshopper",
    "Grebe",
    "Greyhound",
    "Griffonshire",
    "Groenendael",
    "Groundhog ",
    "Grouper",
    "Grouse",
    "Grunion",
    "Guppy",
    "Haddock",
    "Hagfish",
    "Haikouichthys",
    "Hainosaurus",
    "Halibut",
    "Hallucigenia",
    "Hamster",
    "Hare",
    "Harrier",
    "Hartebeest",
    "Hatzegopteryx",
    "Havamalt",
    "Havanese",
    "Havapoo",
    "Havashire",
    "Havashu",
    "Hawk",
    "Hedgehog",
    "Helicoprion",
    "Hellbender",
    "Heron",
    "Herrerasaurus",
    "Herring",
    "Himalayan",
    "Hippopotamus",
    "Hogfish",
    "Hokkaido",
    "Hoopoe",
    "Horgi",
    "Hornbill",
    "Hornet",
    "Horse",
    "Horsefly",
    "Housefly",
    "Hovasaurus",
    "Hovawart",
    "Human",
    "Hummingbird",
    "Huntaway",
    "Huskador",
    "Huskita",
    "Husky",
    "Huskydoodle",
    "Hyaenodon",
    "Hyena",
    "Ibex",
    "Ibis",
    "Icadyptes",
    "Ichthyosaurus",
    "Ichthyostega",
    "Iguana",
    "Iguanodon",
    "Impala",
    "Inchworm",
    "Indri",
    "Insect",
    "Insects",
    "Jabiru",
    "Jacana",
    "Jack-Chi",
    "Jackabee",
    "Jackal",
    "Jackdaw",
    "Jackrabbit",
    "Jagdterrier",
    "Jaguar",
    "Javanese",
    "Jellyfish",
    "Jerboa",
    "Junglefowl",
    "Kagu",
    "Kakapo",
    "Kangaroo",
    "Katydid",
    "Kea",
    "Keagle",
    "Keelback",
    "Keeshond",
    "Kestrel",
    "Kiang",
    "Killdeer",
    "Killifish",
    "Kingfisher",
    "Kingklip",
    "Kinkajou",
    "Kishu",
    "Kiwi",
    "Klipspringer",
    "Knifefish",
    "Koala",
    "Kodkod",
    "Komondor",
    "Kooikerhondje",
    "Koolie",
    "Kouprey",
    "Kowari",
    "Krait",
    "Krill",
    "Kudu",
    "Kuvasz",
    "Labahoula",
    "Labmaraner",
    "Labrabull",
    "Labradane",
    "Labradoodle",
    "Labraheeler",
    "Labrottie",
    "Ladybug",
    "Ladyfish",
    "Lamprey",
    "Lancetfish",
    "Leech",
    "Leedsichthys",
    "Lemming",
    "Lemur",
    "Leonberger",
    "Leopard",
    "Leptocephalus",
    "Lhasapoo",
    "Liger",
    "Limpet",
    "Linnet",
    "Lion",
    "Lionfish",
    "Liopleurodon",
    "Livyatan",
    "Lizard",
    "Lizardfish",
    "Llama",
    "Loach",
    "Lobster",
    "Locust",
    "Lorikeet",
    "Loris",
    "Lowchen",
    "Lumpfish",
    "Lungfish",
    "Lurcher",
    "Lynx",
    "Lyrebird",
    "Lystrosaurus",
    "Macaque",
    "Macaw",
    "Machaeroides",
    "Macrauchenia",
    "Maggot",
    "Magpie",
    "Magyarosaurus",
    "Maiasaura",
    "Malchi",
    "Mallard",
    "Malteagle",
    "Maltese",
    "Maltipom",
    "Maltipoo",
    "Mamba",
    "Manatee",
    "Mandrill",
    "Margay",
    "Markhor",
    "Marmoset",
    "Marmot",
    "Masiakasaurus",
    "Massasauga",
    "Mastador",
    "Mastiff",
    "Mauzer",
    "Mayfly",
    "Meagle",
    "Mealybug",
    "Meerkat",
    "Megalania",
    "Megalochelys",
    "Megalodon",
    "Meganeura",
    "Megatherium",
    "Meiolania",
    "Merganser",
    "Microraptor",
    "Miki",
    "Milkfish",
    "Millipede",
    "Mink",
    "Mockingbird",
    "Mojarra",
    "Mole",
    "Mollusk",
    "Molly",
    "Mongoose",
    "Mongrel",
    "Monkey",
    "Monkfish",
    "Moorhen",
    "Moose",
    "Morkie",
    "Mosasaurus",
    "Mosquito",
    "Moth",
    "Mouse",
    "Mouse-Deer ",
    "Mudi",
    "Mudpuppy",
    "Mudskipper",
    "Mule",
    "Muntjac",
    "Muskellunge ",
    "Muskox",
    "Muskrat",
    "Muttaburrasaurus",
    "Nabarlek",
    "Naegleria",
    "Narwhal",
    "Natterjack",
    "Nautilus",
    "Neanderthal",
    "Nebelung",
    "Needlefish",
    "Nematode",
    "Newfoundland",
    "Newfypoo",
    "Newt",
    "Nightingale",
    "Nightjar",
    "Nilgai",
    "Norrbottenspets",
    "Nudibranch",
    "Numbat",
    "Nuralagus",
    "Nuthatch",
    "Nutria",
    "Nyala",
    "Oarfish",
    "Ocelot",
    "Octopus",
    "Oilfish",
    "Okapi",
    "Olingo",
    "Olm",
    "Onager",
    "Opabinia",
    "Opah",
    "Opaleye ",
    "Opossum",
    "Orangutan",
    "Ori-Pei",
    "Oribi",
    "Ornithocheirus",
    "Ornithomimus",
    "Osprey",
    "Ostracod",
    "Ostrich",
    "Otter",
    "Otterhound",
    "Ovenbird",
    "Oviraptor",
    "Owl",
    "Owlfly ",
    "Ox",
    "Oxpecker",
    "Oyster",
    "Pachycephalosaurus",
    "Paddlefish",
    "Pademelon",
    "Palaeophis",
    "Paleoparadoxia",
    "Pangolin",
    "Panther",
    "Papillon",
    "Parakeet",
    "Parasaurolophus",
    "Parrot",
    "Parrotfish",
    "Parrotlet",
    "Partridge",
    "Patagotitan",
    "Peacock",
    "Peagle",
    "Peekapoo",
    "Pekingese",
    "Pelagornis",
    "Pelagornithidae",
    "Pelican",
    "Pelycosaurs",
    "Penguin",
    "Persian",
    "Pheasant",
    "Phorusrhacos",
    "Phytosaurs",
    "Pig",
    "Pigeon",
    "Pika",
    "Pinfish",
    "Pipefish",
    "Piranha",
    "Pitador",
    "Pitsky",
    "Platybelodon",
    "Platypus",
    "Plesiosaur",
    "Pliosaur",
    "Pointer",
    "Polacanthus",
    "Polecat",
    "Pomapoo",
    "Pomchi",
    "Pomeagle",
    "Pomeranian",
    "Pomsky",
    "Poochon",
    "Poodle",
    "Poogle",
    "Porcupine",
    "Porcupinefish",
    "Possum",
    "Potoo",
    "Potoroo",
    "Prawn",
    "Procoptodon",
    "Pronghorn",
    "Psittacosaurus",
    "Pteranodon",
    "Pterodactyl",
    "Pudelpointer",
    "Puertasaurus",
    "Pufferfish",
    "Puffin",
    "Pug",
    "Pugapoo",
    "Puggle",
    "Pugshire",
    "Puli",
    "Puma",
    "Pumi",
    "Purussaurus",
    "Pyrador",
    "Pyredoodle",
    "Pyrosome",
    "Python",
    "Quagga",
    "Quail",
    "Quetzal",
    "Quokka",
    "Quoll",
    "Rabbit",
    "Raccoon",
    "Ragamuffin",
    "Ragdoll",
    "Raggle",
    "Rat",
    "Rattlesnake",
    "Redstart",
    "Reindeer",
    "Repenomamus",
    "Rhamphosuchus",
    "Rhea",
    "Rhinoceros",
    "Roadrunner",
    "Robin",
    "Rockfish",
    "Rodents",
    "Rooster",
    "Rotterman",
    "Rottle",
    "Rottsky",
    "Rottweiler",
    "Sable",
    "Saiga",
    "Sailfish",
    "Salamander",
    "Salmon",
    "Saluki",
    "Sambar",
    "Samoyed",
    "Sandpiper",
    "Sandworm",
    "Saola",
    "Sapsali",
    "Sarcosuchus",
    "Sardines",
    "Sarkastodon",
    "Sarplaninac",
    "Sauropoda",
    "Sawfish",
    "Scallops",
    "Schapendoes",
    "Schipperke",
    "Schneagle",
    "Schnoodle",
    "Scorpion",
    "Sculpin",
    "Scutosaurus",
    "Seagull",
    "Seahorse",
    "Seal",
    "Serval",
    "Seymouria",
    "Shantungosaurus",
    "Shark",
    "Shastasaurus",
    "Sheep",
    "Sheepadoodle",
    "Shepadoodle",
    "Shepkita",
    "Shepweiler",
    "Shichi",
    "Shikoku",
    "Shiranian",
    "Shollie",
    "Shrew",
    "Shrimp",
    "Siamese",
    "Siberian",
    "Siberpoo",
    "Sidewinder",
    "Simbakubwa",
    "Sinosauropteryx",
    "Sivatherium",
    "Skua",
    "Skunk",
    "Sloth",
    "Slug",
    "Smilosuchus",
    "Snail",
    "Snailfish",
    "Snake",
    "Snorkie",
    "Snowshoe",
    "Somali",
    "Spalax",
    "Spanador",
    "Sparrow",
    "Sparrowhawk",
    "Sphynx",
    "Spider",
    "Spinosaurus",
    "Sponge",
    "Springador",
    "Springbok",
    "Springerdoodle",
    "Squid",
    "Squirrel",
    "Squirrelfish",
    "Stabyhoun",
    "Starfish",
    "Stingray",
    "Stoat",
    "Stonechat",
    "Stonefish",
    "Stork",
    "Stromatolite",
    "Stupendemys",
    "Sturgeon",
    "Styracosaurus",
    "Suchomimus",
    "Suckerfish",
    "Supersaurus",
    "Superworm",
    "Surgeonfish",
    "Swallow",
    "Swan",
    "Swordfish",
    "Taipan",
    "Takin",
    "Tamarin",
    "Tamaskan",
    "Tang",
    "Tapir",
    "Tarantula",
    "Tarbosaurus",
    "Tarpon",
    "Tarsier",
    "Tenrec",
    "Termite",
    "Terrier",
    "Tetra",
    "Thalassomedon",
    "Thanatosdrakon",
    "Therizinosaurus",
    "Theropod",
    "Thrush",
    "Thylacoleo",
    "Thylacosmilus",
    "Tick",
    "Tiffany",
    "Tiger",
    "Tiktaalik",
    "Titanoboa",
    "Titanosaur",
    "Toadfish",
    "Torkie",
    "Tornjak",
    "Tortoise",
    "Tosa",
    "Toucan",
    "Towhee",
    "Toxodon",
    "Treecreeper",
    "Treehopper",
    "Triggerfish",
    "Troodon",
    "Tropicbird",
    "Trout",
    "Tuatara",
    "Tuna",
    "Turaco",
    "Turkey",
    "Turnspit",
    "Turtles",
    "Tusoteuthis",
    "Tylosaurus",
    "Uakari",
    "Uguisu",
    "Uintatherium",
    "Umbrellabird",
    "Unau ",
    "Urial",
    "Uromastyx ",
    "Utonagan",
    "Vaquita",
    "Veery",
    "Vegavis",
    "Velociraptor",
    "Vicuña",
    "Vinegaroon",
    "Viper",
    "Viperfish",
    "Vizsla",
    "Vole",
    "Vulture",
    "Waimanu",
    "Wallaby",
    "Walrus",
    "Warbler",
    "Warthog",
    "Wasp",
    "Waterbuck",
    "Weasel",
    "Weimaraner",
    "Weimardoodle",
    "Westiepoo",
    "Whimbrel",
    "Whinchat",
    "Whippet",
    "Whiting",
    "Whoodle",
    "Wildebeest",
    "Wiwaxia",
    "Wolf",
    "Wolffish",
    "Wolverine",
    "Wombat",
    "Woodlouse",
    "Woodpecker",
    "Woodrat",
    "Worm",
    "Wrasse",
    "Wryneck",
    "Xeme ",
    "Xenacanthus",
    "Xenoceratops",
    "Xenoposeidon",
    "Xenotarsosaurus",
    "Xerus",
    "Xiaosaurus",
    "Xiaotingia",
    "Xiongguanlong",
    "Xiphactinus",
    "Xoloitzcuintli",
    "Yabby",
    "Yak",
    "Yarara",
    "Yellowhammer",
    "Yellowjacket ",
    "Yellowthroat",
    "Yoranian",
    "Yorkiepoo",
    "Zebra",
    "Zebrafish ",
    "Zebu",
    "Zokor",
    "Zonkey",
];

const defaultWordlist = [adjectives, wordset2];

const SAFE_BITS = 32; // actually 53 but js doesn't do 64 bit bitwise by default
const MAX_ITERATIONS = 1000;

const getMask = (
    wordlists: readonly string[][],
): [bits: number, mask: number] =>
{
    if (wordlists.length === 0) throw new Error("No wordlists provided");
    if (wordlists.length > SAFE_BITS) throw new Error("Too many wordlists provided");

    const bits = Math.floor(SAFE_BITS / wordlists.length);

    const mask = (1 << bits) - 1;

    if (wordlists !== defaultWordlist)
    {
        wordlists.forEach((wordlist) =>
        {
            if (wordlist.length === 0) throw new Error("Empty wordlist provided");
            if (wordlist.length > mask) throw new Error("Too many words provided");
        });
    }

    return [bits, mask];
};

const sortIndex = (list: string[]) => list
    .map((s, i) => ({s, i}))
    .sort((a, b) => a.s.length - b.s.length)
    .map(({i}) => i);

export const getReadableId = (
    inputID: string,
    maxLength: number,
    wordlists: readonly string[][] = defaultWordlist,
) =>
{
    const [bits, mask] = getMask(wordlists);

    const minLength = wordlists.reduce(
        (acc, list) => acc + list[sortIndex(list)[0]].length,
        wordlists.length-1,
    );

    if (minLength > maxLength) throw new Error(`Cannot create name that short. (${maxLength} < ${minLength})`);

    const bigMask = SAFE_BITS as number && (-1 >>> SAFE_BITS); // 2 ^ 32 - 1
    const seed = Util.cyrb53(inputID) & bigMask;

    const rand = splitMix32(seed);

    const indexes = new Array<number>(wordlists.length);
    const words = new Array<string>(wordlists.length);

    const updateIndexes = (hash: number) => void wordlists.forEach((wordlist, i) =>
    {
        const chunk = (hash >>> bits*i) & mask;

        const index = Math.floor(wordlist.length * (chunk / mask));

        indexes[i] = index;
        words[i] = wordlists[i][index];
    });

    let iteration = 0, result: string;

    do
    {
        updateIndexes(rand());

        result = words.join(" ");

        if (result.length <= maxLength) break;
    } while (++iteration < MAX_ITERATIONS);

    const anneal = () =>
    {
        for (const word of sortIndex(words))
        {
            const length = words[word].length;

            let index = indexes[word];

            do
            {
                index++;
                if (index >= wordlists[word].length) index = 0;

                if (wordlists[word][index].length < length) break;
            } while (index !== indexes[word]);

            if (index !== indexes[word])
            {
                indexes[word] = index;
                words[word] = wordlists[word][index];
                result = words.join(" ");

                break;
            }
        }
    };

    for (let len = result.length; len > maxLength; )
    {
        anneal();

        if (result.length >= len)
        {
            result = "Spooky Name";

            break;
        }

        len = result.length;
    }

    return result;
};
